<script>
    import _               from 'lodash'
    import { getContext }  from 'svelte'
    import { fade }        from 'svelte/transition'
    import validate        from 'validate.js'
    import * as api        from '../../../shared/api.js'
    import TestIntegration from './TestIntegration.svelte'    

    export let domain
    export let place
    export let config
    export let constraints
    
    let working = false
    let error   = false

    $: errors    = validate(config, constraints, { fullMessages: false }) || {}
    $: hasErrors = Object.keys(errors).length > 0

    const inventory = getContext('inventory')
    const item      = getContext('item')

    function save() {
        working = true
        error   = false
        var trimmed = _.mapValues(config, v => _.isString(v) ? _.trim(v) : v);
        const data = {
            place  : place.id,
            config : { active: true, ...trimmed }
        }
        api .post(`/inventory/domain/${domain.id}/connector`, data)
            .then(api.toJsonIf200)
            .then(json => {
                working = false
                error   = false
                inventory.set(json)
                item.close(false /* do not reset */)
            }).catch(err => {
                error   = true
                setTimeout(() => { 
                    working = false
                    error   = false
                }, 1500)
            })
    }
</script>
<div class="container">
    <div class="left">
        <form class="ui form" class:error={hasErrors}>
            <slot {errors} {working}></slot>
        </form>
        <TestIntegration {place} {domain} {config} disabled={hasErrors}></TestIntegration>    
    </div>
    <div class="right">
        <button class="ui blue button" 
                class:loading={working} 
                class:disabled={working || hasErrors} 
                on:click={save}>Salvar</button>
        {#if error}
            <div transition:fade class="ui red horizontal basic label">erro</div>
        {/if}
    </div>
</div>
<style>
    .container {
        display: flex;

    }

    .left {
        flex: 1;
    }

    .right {
        /* border: 1px solid red; */
        flex: 1;
        align-self: flex-end;
        margin: 0 20px;
        display: flex;
        align-items: flex-end;
    }

    .form {
        margin-bottom: 2em;
    }

</style>

